import { UserContact } from 'model/business-types';
import { TravelSegment } from './trip-details';

export interface HolidayTrip {
  name: string | null;
  travelers: HolidayMaker[];
  segments: TravelSegment[];
}

export interface HolidayMaker {
  user: UserContact | null;
  personalPhone: string | null;
  relatedTravelers: RelatedTraveler[];
}

export interface RelatedTraveler {
  name: string | null;
  relation: string | null;
}

export function initHolidayTrip(data?: Partial<HolidayTrip>): HolidayTrip {
  return { name: null, travelers: [], segments: [], ...data };
}

export function initHolidayMaker(data?: Partial<HolidayMaker>): HolidayMaker {
  return { user: null, personalPhone: null, relatedTravelers: [], ...data };
}

export function initRelatedTraveler(data?: Partial<RelatedTraveler>): RelatedTraveler {
  return { name: null, relation: null, ...data };
}
